import {
  ChartAPIReturn,
  EventsConfig,
  INSIGHTS_IN_DOMAIN_CHANGE_CUSTOM_EVENT,
  InsightsInDomain,
  InsightsInDomainDetail,
  InsightsInDomainEvent,
} from '@toggle/chart';
import { ChartInsight } from '@toggle/toggle';
import { RefObject, useEffect, useState } from 'react';

interface UseInsightsInDomainProps {
  canvasRef: RefObject<HTMLCanvasElement | null>;
  eventsConfig: EventsConfig;
  chartApiRef: RefObject<ChartAPIReturn | null>;
  insights: ChartInsight[];
}

export const useInsightsInDomain = ({
  canvasRef,
  eventsConfig,
  chartApiRef,
  insights,
}: UseInsightsInDomainProps) => {
  const [insightsInDomain, setInsightsInDomain] = useState<InsightsInDomain[]>(
    []
  );
  const [zoomIntoViewText, setZoomIntoViewText] =
    useState<InsightsInDomainDetail['helperText']>(null);

  useEffect(() => {
    const canvasElement = canvasRef.current;

    const insightsInDomainListener = (event: Event) => {
      const detail = (event as InsightsInDomainEvent).detail;

      if (detail.insightsInDomain) {
        setInsightsInDomain(detail.insightsInDomain);
      }

      setZoomIntoViewText(detail.helperText);
    };

    if (canvasElement) {
      canvasElement.addEventListener(
        INSIGHTS_IN_DOMAIN_CHANGE_CUSTOM_EVENT,
        insightsInDomainListener
      );
    }

    return () => {
      canvasElement?.removeEventListener(
        INSIGHTS_IN_DOMAIN_CHANGE_CUSTOM_EVENT,
        insightsInDomainListener
      );
    };
  }, [eventsConfig]);

  useEffect(() => {
    if (chartApiRef.current) {
      const articleInsights = eventsConfig.TMI ? insights : [];

      chartApiRef.current.displayInsights(articleInsights);
    }
  }, [eventsConfig, insights]);

  return {
    insightsInDomain,
    zoomIntoViewText,
  };
};
